import { NoAccessCard } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import { MaxWidthWrapper } from './MaxWidthWrapper'

import { RefreshAccess } from './RefreshAccess'

import type { FC } from 'react'

export const NoAccessSign: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'no_access',
  })

  return (
    <div className="mx-4 mt-6 md:mx-0">
      <MaxWidthWrapper>
        <NoAccessCard>
          <NoAccessCard.LockIcon />
          <NoAccessCard.Header>{t('title')}</NoAccessCard.Header>
          <NoAccessCard.Description>
            <p className="mb-6 text-xl">{t('description')}</p>
            <RefreshAccess />
          </NoAccessCard.Description>
          <NoAccessCard.ContactInfo>
            <NoAccessCard.ContactInfoHeader>
              {t('contact_info.header')}
            </NoAccessCard.ContactInfoHeader>
            {t('contact_info.description').length > 0
              && (
                <NoAccessCard.ContactInfoDescription>
                  {t('contact_info.description')}
                </NoAccessCard.ContactInfoDescription>
              )}
            {t('contact_info.link.text').length > 0
              && (
                <NoAccessCard.ContactInfoDescription>
                  {`${t('contact_info.link.prefix')} `}
                  <a className="kui-link" target="_blank" href={t('contact_info.link.href')} rel="noreferrer">
                    {t('contact_info.link.text')}
                  </a>
                  {` ${t('contact_info.link.suffix')}`}
                </NoAccessCard.ContactInfoDescription>
              )}
            <NoAccessCard.ContactInfoPhone>
              {t('contact_info.phone')}
            </NoAccessCard.ContactInfoPhone>
            {t('contact_info.email').length > 0
              && (
                <NoAccessCard.ContactInfoEmail>
                  {t('contact_info.email')}
                </NoAccessCard.ContactInfoEmail>
              )}
          </NoAccessCard.ContactInfo>
        </NoAccessCard>
      </MaxWidthWrapper>
    </div>
  )
}
